"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ArrowDirection = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _context = require("../context");

var _utils = require("../utils");

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ArrowDirection;
exports.ArrowDirection = ArrowDirection;

(function (ArrowDirection) {
  ArrowDirection["Up"] = "up";
  ArrowDirection["Down"] = "down";
  ArrowDirection["Forward"] = "forward";
  ArrowDirection["Back"] = "back";
})(ArrowDirection || (exports.ArrowDirection = ArrowDirection = {}));

var getRotation = function getRotation(direction) {
  if (direction === ArrowDirection.Up) {
    return 0;
  }

  if (direction === ArrowDirection.Down) {
    return 180;
  }

  if (direction === ArrowDirection.Forward) {
    return 90;
  }

  if (direction === ArrowDirection.Back) {
    return 270;
  }

  return 0;
};

var commonStyles = {
  width: 0,
  height: 0,
  backgroundColor: 'transparent'
};
var ArrowOuter = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterProps)(['size', 'direction', 'borderColor'])
})(function (_ref) {
  var theme = _ref.theme,
      size = _ref.size,
      direction = _ref.direction,
      borderColor = _ref.borderColor;
  return _objectSpread(_objectSpread({}, commonStyles), {}, {
    position: 'relative',
    borderBottom: "".concat(size, "px solid ").concat(theme.selectors.colorOrNull(borderColor) || borderColor),
    borderLeft: "".concat(size, "px solid transparent"),
    borderRight: "".concat(size, "px solid transparent"),
    transform: "rotate(".concat(getRotation(direction), "deg)"),
    transition: '0.2s transform'
  });
});
ArrowOuter.displayName = 'ArrowOuter';
var ArrowInner = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterProps)(['size', 'backgroundColor', 'borderWidth'])
})(function (_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size,
      backgroundColor = _ref2.backgroundColor,
      borderWidth = _ref2.borderWidth;
  // Subtract an extra pixel to increase the thickness of the border slightly.
  // Due to the arrow being rotated, the border will never be an exact number
  // of pixels, and being 0.5 pixels too thick is less noticeable than being
  // 0.5 pixels too thin, especially when borderWidth = 1.
  var width = size - borderWidth - 1;
  return _objectSpread(_objectSpread({}, commonStyles), {}, {
    position: 'absolute',
    left: 0 - width,
    bottom: 0 - size,
    borderBottom: "".concat(width, "px solid ").concat(theme.selectors.colorOrNull(backgroundColor) || backgroundColor),
    borderLeft: "".concat(width, "px solid transparent"),
    borderRight: "".concat(width, "px solid transparent")
  });
});
ArrowInner.displayName = 'ArrowInner';

var Arrow = function Arrow(_ref3) {
  var size = _ref3.size,
      _ref3$direction = _ref3.direction,
      direction = _ref3$direction === void 0 ? ArrowDirection.Up : _ref3$direction,
      _ref3$backgroundColor = _ref3.backgroundColor,
      backgroundColor = _ref3$backgroundColor === void 0 ? 'neutral0' : _ref3$backgroundColor,
      _ref3$borderColor = _ref3.borderColor,
      borderColor = _ref3$borderColor === void 0 ? 'neutral50' : _ref3$borderColor,
      _ref3$borderWidth = _ref3.borderWidth,
      borderWidth = _ref3$borderWidth === void 0 ? 1 : _ref3$borderWidth;
  return (0, _core.jsx)(ArrowOuter, {
    size: size,
    direction: direction,
    borderColor: borderColor
  }, (0, _core.jsx)(ArrowInner, {
    "data-test-component": "StencilArrow",
    size: size,
    backgroundColor: backgroundColor,
    borderWidth: borderWidth
  }));
};

Arrow.displayName = 'Arrow';
var _default = Arrow;
exports.default = _default;